import { render } from "./mgrCdSelectBox2.vue?vue&type=template&id=2a23d7a8"
import script from "./mgrCdSelectBox2.vue?vue&type=script&lang=js"
export * from "./mgrCdSelectBox2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__